import React from 'react';
import { useTranslation } from 'react-i18next';
import { ShowDialogParams } from '@/store/dialog/types';

import { TermsAndConditionsBody } from '../components/TermsAndConditionsBody';


export const useTermsAndConditionsModalParams = () => {
    const { t } = useTranslation();

    const getTermsAndConditionsModalParams = (): ShowDialogParams => ({
        title: t('termsandconditions'),
        cancelLabel: t('cancel'),
        body: <TermsAndConditionsBody />,
        isHiddenManually: true,
        width: "1024px",
    });

    return { getTermsAndConditionsModalParams };
};